module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-dialog', {
    attrs: {
      "title": "选择图片",
      "visible": _vm.dialogFormVisible,
      "top": "141px",
      "before-close": _vm.handleClose,
      "width": "90%",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticStyle: {
      "width": "400px",
      "height": "320px",
      "margin-right": "30px"
    },
    attrs: {
      "id": "cut_container"
    }
  }, [_c('h3', [_vm._v("裁剪框")]), _vm._v(" "), _c('div', {
    staticClass: "uploadBody",
    staticStyle: {
      "background-color": "#d6d6d6",
      "height": "320px"
    }
  }, [_c('img', {
    attrs: {
      "id": "image"
    }
  })]), _vm._v(" "), _c('input', {
    staticStyle: {
      "width": "80%",
      "margin-top": "5%",
      "display": "block"
    },
    attrs: {
      "type": "file",
      "id": "change_btn"
    },
    on: {
      "change": function($event) {
        return _vm.fileChange($event)
      }
    }
  })]), _vm._v(" "), _c('div', {}, [_c('h3', [_vm._v("裁剪预览框")]), _vm._v(" "), _c('div', {
    staticClass: "pre-container"
  }, [_c('div', {
    staticClass: "small"
  }), _vm._v(" "), _c('div', {
    staticClass: "cavans"
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "text-right mt20"
  }, [_c('el-button', {
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.upload2()
      }
    }
  }, [_vm._v("上传"), (_vm.percent) ? _c('span') : _vm._e()])], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-2f7d1f0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./~/_xiaozhu@2022.5.14@xiaozhu/vue/components/admin/cropUploadPicNew.vue
// module id = 252
// module chunks = 101